
import { Component, Mixins } from 'vue-property-decorator';
import { Consent } from '~/interfaces/user.interface';
import { UserModule } from '~/store/modules/user';
import PopupMixin from '~common-mixins/PopupMixin';

@Component
export default class MarketingConsentsPopup extends Mixins(PopupMixin) {
    get UserConsentsHistory() {
        return UserModule.brandsConsentsHistory;
    }

    reversedArray(array: Consent[]) {
        // copy and reverse (reverse changes the original array)
        return JSON.parse(JSON.stringify(array)).reverse() as Consent[];
    }
}
